import React, { useEffect, useState } from "react";
import { apiService } from "../../services/apiService";
import { Grid, Box, Typography, Card, CardContent } from "@mui/material";
import { useAuth } from "../../hooks/useAuth";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   ResponsiveContainer,
// } from "recharts";

const Dashboard = () => {
  const { getUserName } = useAuth();

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await apiService.get("/user/summary");
        console.log("User summary:", res.data);
      } catch (err) {
        console.error("User summary error:", err);
      }
    };

    fetchSummary();
  }, []);

  const [summary, setSummary] = useState(null);

  useEffect(() => {
    const fetchAndSet = async () => {
      try {
        const res = await apiService.get("/user/summary");
        const data = res.data.result || res.data;
        setSummary(data);
      } catch (err) {
        // keep summary null on error
      }
    };

    fetchAndSet();
  }, []);

  // Chart data for User Growth
  // const chartData = [
  //   { name: "0", totalUsers: 5, maleUsers: 3, femaleUsers: 2 },
  //   { name: "10", totalUsers: 40, maleUsers: 28, femaleUsers: 12 },
  //   { name: "20", totalUsers: 35, maleUsers: 45, femaleUsers: 22 },
  //   { name: "30", totalUsers: 58, maleUsers: 42, femaleUsers: 40 },
  //   { name: "40", totalUsers: 35, maleUsers: 25, femaleUsers: 18 },
  //   { name: "50", totalUsers: 42, maleUsers: 38, femaleUsers: 25 },
  //   { name: "60", totalUsers: 35, maleUsers: 32, femaleUsers: 28 },
  //   { name: "70", totalUsers: 60, maleUsers: 52, femaleUsers: 24 },
  // ];

  const getTrendProps = (t) => {
    if (t === undefined || t === null) return { text: "", color: "#666666" };
    const arrow = t > 0 ? "↑" : t < 0 ? "↓" : "";
    const text = `${arrow} ${Math.abs(Number(t)).toFixed(2)}% vs last month`;
    const color = t < 0 ? "#c62828" : t > 0 ? "#2e7d32" : "#666666";
    return { text, color };
  };

  const statsCards = [
    {
      title: "Total User",
      value: summary ? Number(summary.users).toLocaleString("en-US") : "--",
      subtitle: summary ? getTrendProps(summary.users_trend).text : "",
      subtitleColor: summary
        ? getTrendProps(summary.users_trend).color
        : "#666666",
      color: "#E1AD01",
    },
    {
      title: "Male User",
      value: summary ? Number(summary.males).toLocaleString("en-US") : "--",
      subtitle: summary ? getTrendProps(summary.male_trend).text : "",
      subtitleColor: summary
        ? getTrendProps(summary.male_trend).color
        : "#666666",
      color: "#E1AD01",
    },
    {
      title: "Female Users",
      value: summary ? Number(summary.females).toLocaleString("en-US") : "--",
      subtitle: summary ? getTrendProps(summary.female_trend).text : "",
      subtitleColor: summary
        ? getTrendProps(summary.female_trend).color
        : "#666666",
      color: "#E1AD01",
    },
    {
      title: "Other Users",
      value: summary ? Number(summary.other).toLocaleString("en-US") : "--",
      subtitle: summary ? getTrendProps(summary.other_trend).text : "",
      subtitleColor: summary
        ? getTrendProps(summary.other_trend).color
        : "#666666",
      color: "#E1AD01",
    },
    {
      title: "Total Revenue",
      value: summary ? `$${summary.revenue.toLocaleString("en-US")}` : "--",
      subtitle: summary ? getTrendProps(summary.revenue_trend).text : "",
      subtitleColor: summary
        ? getTrendProps(summary.revenue_trend).color
        : "#666666",
      color: "#E1AD01",
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#000000",
        minHeight: "100%",
        width: "100%",
      }}
    >
      {/* Welcome Message */}
      <Typography
        variant="h4"
        sx={{
          color: "#FFFFFF",
          fontWeight: 600,
          marginBottom: 3,
          fontSize: { xs: "24px", md: "32px" },
        }}
      >
        Welcome back, {getUserName()}!
      </Typography>

      {/* Great News Banner */}
      {/* <Box
        sx={{
          backgroundColor: "#A8E6CF",
          borderRadius: "12px",
          padding: "16px 20px",
          marginBottom: 4,
          border: "1px solid #90D4AA",
        }}
      >
        <Typography
          sx={{
            color: "#1B5E20",
            fontSize: "16px",
            fontWeight: 600,
          }}
        >
          Great News!
          <Typography component="span" sx={{ fontWeight: 400, ml: 1 }}>
            You've earned $2,340 this month, which is 28% more than last month.
          </Typography>
        </Typography>
      </Box> */}

      {/* Stats Cards */}
      <Grid container spacing={2} sx={{ marginBottom: 4 }}>
        {statsCards.map((card, index) => (
          <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }} key={index}>
            <Card
              sx={{
                borderRadius: "16px",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#FFFFFF",
                position: "relative",
                overflow: "visible",
                height: "100%",
              }}
            >
              {/* Yellow accent line */}
              <Box
                sx={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: "8px",
                  height: "100px",
                  my: "auto",
                  backgroundColor: card.color,
                  borderTopRightRadius: "16px",
                  borderBottomRightRadius: "16px",
                }}
              />
              <CardContent sx={{ padding: "24px" }}>
                <Typography
                  variant="h3"
                  sx={{
                    color: "#1A1A1A",
                    fontWeight: 700,
                    fontSize: "36px",
                    marginBottom: 1,
                    lineHeight: 1,
                  }}
                >
                  {card.value}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    color: "#666666",
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: 1,
                  }}
                >
                  {card.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: card.subtitleColor || "#666666",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  {card.subtitle}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Chart Section */}
      {/* <Card
        sx={{
          borderRadius: "16px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#FFFFFF",
          padding: 3,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: "#1A1A1A",
            fontWeight: 600,
            marginBottom: 3,
            fontSize: "24px",
          }}
        >
          User Growth
        </Typography>

        <Box sx={{ width: "100%", height: 400 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={chartData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="#E0E0E0"
                horizontal={true}
                vertical={true}
              />
              <XAxis
                dataKey="name"
                axisLine={false}
                tickLine={false}
                tick={{ fill: "#666666", fontSize: 12 }}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tick={{ fill: "#666666", fontSize: 12 }}
                domain={[0, 70]}
              />
              <Line
                type="monotone"
                dataKey="totalUsers"
                stroke="#4CAF50"
                strokeWidth={3}
                dot={{ fill: "#4CAF50", strokeWidth: 2, r: 4 }}
                activeDot={{ r: 6, fill: "#4CAF50" }}
              />
              <Line
                type="monotone"
                dataKey="maleUsers"
                stroke="#E1AD01"
                strokeWidth={3}
                dot={{ fill: "#E1AD01", strokeWidth: 2, r: 4 }}
                activeDot={{ r: 6, fill: "#E1AD01" }}
              />
              <Line
                type="monotone"
                dataKey="femaleUsers"
                stroke="#E57373"
                strokeWidth={3}
                dot={{ fill: "#E57373", strokeWidth: 2, r: 4 }}
                activeDot={{ r: 6, fill: "#E57373" }}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </Card> */}
    </Box>
  );
};

export default Dashboard;
